import { render, staticRenderFns } from "./RimuoviGruppo.vue?vue&type=template&id=00d82a36&"
import script from "./RimuoviGruppo.vue?vue&type=script&lang=js&"
export * from "./RimuoviGruppo.vue?vue&type=script&lang=js&"
import style0 from "./RimuoviGruppo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports